import React, { useEffect, useRef, useState } from "react";
import "react-chat-elements/dist/main.css";
import { useTranslation } from "react-i18next";
import {
  getServiceProviderUserChatAction,
  getServiceProviderUserChatDetailsByIdAction,
  sendUserChatMessageAction,
} from "../../../../../../redux/services/service-provider-user-chat/serviceProviderUserChatServices";
import { useDispatch, useSelector } from "react-redux";
import ChatComponent from "../../../../../common/chat-component/ChatComponent";
import styles from "./StaffChat.module.scss";
import Actions from "../../../../../../redux/actions";

const StaffChat = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /*loading dependencies */
  const [loading, setLoading] = useState(false);
  /*loading dependencies */

  /* table dependencies */
  const { serviceProviderUserChat, serviceProviderUserChatDetailsById } =
    useSelector((state) => state.serviceProviderUserChat);
  /* table dependencies */

  /* function definition to get table data */
  const handleGetTableData = () => {
    dispatch(
      Actions.createAction(
        Actions.GET_SERVICE_PROVIDER_USER_CHAT_DETAILS_BY_ID,
        { serviceProviderUserChatDetailsById: {} }
      )
    );
    dispatch(
      Actions.createAction(Actions.GET_SERVICE_PROVIDER_USER_CHAT_LIST, {
        serviceProviderUserChat: {
          data: [],
        },
      })
    );
    dispatch(getServiceProviderUserChatAction(setLoading));
  };
  /* function definition to get table data */

  useEffect(() => {
    handleGetTableData();
  }, []);

  /* on chat list clicked */
  const onChatClicked = (element) => {
    const selectedServiceProviderUserChatId = element?._id;
    const dataToBeSent = { selectedServiceProviderUserChatId };
    dispatch(
      getServiceProviderUserChatDetailsByIdAction(setLoading, dataToBeSent)
    );
  };
  /* on chat list clicked */

  /* on submit */
  const onSubmit = (values) => {
    const dataToBeSent = {
      ...values,
      conversation_id: serviceProviderUserChatDetailsById._id,
    };
    dispatch(sendUserChatMessageAction(dataToBeSent, setLoading));
  };
  /* on submit */

  return (
    <>
      <ChatComponent
        chatList={serviceProviderUserChat?.data?.map((element) => ({
          ...element?.to_user,
        }))}
        chatMessages={serviceProviderUserChatDetailsById?.messages}
        onChatClicked={onChatClicked}
        // onSubmit={onSubmit}
        disabled={true}
      />
    </>
  );
};

export default StaffChat;
